var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 41.46c0 .849-.695 1.54-1.55 1.54h-38.9c-.855 0-1.55-.691-1.55-1.54V11.54c0-.849.695-1.54 1.55-1.54h38.9c.855 0 1.55.691 1.55 1.54v29.92zM54.917 51.731a.555.555 0 01-.473.268H41.556a.555.555 0 01-.473-.268.57.57 0 01-.024-.548c.86-1.744 1.298-3.972 1.298-6.62a.56.56 0 01.557-.564h10.172a.56.56 0 01.556.564c0 2.648.437 4.876 1.3 6.62a.57.57 0 01-.025.548zM29.372 9A3.375 3.375 0 0026 12.371v28.835a3.375 3.375 0 003.372 3.371h11.609a.46.46 0 01.461.461c0 4.001-1.381 5.514-1.975 5.978a.457.457 0 01-.284.098h-3.817a.944.944 0 000 1.886h25.269a.945.945 0 00.943-.943.945.945 0 00-.943-.943h-3.831a.457.457 0 01-.284-.098c-.59-.462-1.961-1.969-1.961-5.978a.46.46 0 01.461-.461h11.609A3.375 3.375 0 0070 41.206V12.371A3.375 3.375 0 0066.629 9H29.372z",
    fill: "#242726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.528 16.81a.99.99 0 00-.292.702l-.508 6.513h-6.005a.988.988 0 00-.992.993v3.002a.99.99 0 00.992.993l6.513.508v6.005a.99.99 0 00.993.993h3.002a.99.99 0 00.993-.993l.509-6.513h6.005a.99.99 0 00.993-.993v-3.002a.99.99 0 00-.993-.993l-6.514-.508-.417-6.682c-.135-.072-.354-.146-.724-.198-.518-.073-1.396-.121-3.555.173z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D3AEB2",
    strokeWidth: 0.7,
    fill: "#F5F0F0",
    cx: 16.1,
    cy: 16.1,
    r: 15.75
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Prata-Regular, Prata",
    fontSize: 15.4,
    fill: "#88456E"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.443,
    y: 21.8
  }, "1")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInsurance);
export default __webpack_public_path__ + "static/media/health-insurance.9970ce3cc417576385a3d0b92c3a8018.svg";
export { ForwardRef as ReactComponent };